(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const headerSection = document.querySelector('.section-header');
    if (!headerSection) return;
/* ===== Desktop mega menu → melns header ===== */
const desktopMenuDetails = headerSection.querySelectorAll(
  '.header__inline-menu details, .mega-menu'
);

const updateMegaMenuHeader = () => {
  if (window.innerWidth < 990) {
    headerSection.classList.remove('mega-menu-open');
    return;
  }

  const menuIsOpen = Array.from(desktopMenuDetails).some((details) => {
    return details.hasAttribute('open');
  });

  headerSection.classList.toggle('mega-menu-open', menuIsOpen);
};

desktopMenuDetails.forEach((details) => {
  details.addEventListener('toggle', updateMegaMenuHeader);
});

document.addEventListener('click', () => {
  setTimeout(updateMegaMenuHeader, 10);
});

window.addEventListener('resize', updateMegaMenuHeader);

updateMegaMenuHeader();
    // augstums vajadzīgs mobilajam search overlay
    const setHeaderHeight = () => {
      document.documentElement.style.setProperty(
        '--header-height',
        `${headerSection.offsetHeight}px`
      );
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    let lastScroll = window.scrollY;
    const threshold = 50; // cik tālu jānoskrullē, lai vispār ieslēgtos sticky režīms

    const onScroll = () => {
      const current = window.scrollY;

      // Pašā augšā – header uz banera, caurspīdīgs, nav fixed
      if (current <= threshold) {
        headerSection.classList.remove(
          'custom-header--visible',
          'custom-header--hidden'
        );
        lastScroll = current;
        return;
      }

      if (current > lastScroll) {
        // SCROLL DOWN → paslēpjam (caurspīdīgs)
        headerSection.classList.add('custom-header--hidden');
        headerSection.classList.remove('custom-header--visible');
      } else if (current < lastScroll) {
        // SCROLL UP → parādām melnu header
        headerSection.classList.add('custom-header--visible');
        headerSection.classList.remove('custom-header--hidden');
      }

      lastScroll = current;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
        const langSwitch = document.querySelector('.lang-switch');
    if (langSwitch) {
      const toggle = langSwitch.querySelector('.lang-switch__toggle');
      if (toggle) {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          const open = langSwitch.classList.toggle('lang-switch--open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        document.addEventListener('click', (e) => {
          if (!langSwitch.contains(e.target)) {
            langSwitch.classList.remove('lang-switch--open');
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

  });

  } catch(e) { console.error(e); }
})();
})();
